import React, {useEffect, useState} from "react";
import {useSubmitForm} from "../../../../hooks/useSubmitForm/useSubmitForm";
import GenericModal from "../../../../components/modal/GenericModal";
import InputTextArea from "../../../../components/modalComponents/InputTextArea";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {usePropsInputs} from "../../../../hooks/useProps/usePropsInput";
import {getMotivoRechazoBeneficioAPI, rechazarSolicitudBeneficioAPI} from "../../../../consumers/backendApisUrls";
import { useGetOptionsSelect } from "../../../../hooks/useGetOptionsSelect/useGetOptionsSelect";
import InputSelect from '../../../../components/modalComponents/InputSelect';
import { usePropsSelect } from '../../../../hooks/useProps/usePropsSelect';
import { initialAllOptionPromises } from "../../../../helper/utils";

const SECTION_NAME = "noAprobarMotivoBeneficio";
const KEYS = { motivo: "MotivoRechazo", motivoDetalle: "MotivoDetalle" };
const KEYS_DROPDOWN = ["MotivoRechazo"];

const RechazarSolicitudBeneficio = ({ toggleModal, refreshPage, toggleMainModal, idSolicitudBeneficio }) => {
 

    const [formValues, setFormValues] = useState({});
    const [isSending, setIsSending] = useState(false);
    const [submitForm] = useSubmitForm();

    const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
    const [getOption] = useGetOptionsSelect();
    const [allDropdowns, setAllDropdowns] = useState([]);
    const [selectProps] = usePropsSelect(allDropdowns, formValues, setFormValues, SECTION_NAME);
    const [isOtros, setIsOtros] = useState(false);

    const getDropdowns = async () => {
        const dropdownsPromises = () => [
            getOption(getMotivoRechazoBeneficioAPI())
        ];
        await initialAllOptionPromises(
            dropdownsPromises,
            KEYS_DROPDOWN,
            setAllDropdowns
        );
    }

    const handleAction = async () => {
        setIsSending(true);
        const api = rechazarSolicitudBeneficioAPI();
        const payload = getPayload();
        try {
            await submitForm(Object.values(KEYS), api, payload, SECTION_NAME, successHandleCallback);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSending(false);
        }
    };

    const init = async () => {
        getDropdowns();
    };

    const getPayload = () => {
        return {
            IdSolicitudBeneficio: idSolicitudBeneficio,
            ...formValues
        }
    }

    const successHandleCallback = async () => {
        toggleModal();
        toggleMainModal();
        await refreshPage();
    }

    useEffect(() => {
        init();
    }, []);


    return (
        <GenericModal
            titulo="No Aprobar"
            showModal={toggleModal}
            width={"600px"}
        >
            <div className="modal-body pt-0 pl-0">
                <div className="container-fluid">
                    <InputSelect
                        label="Motivo"
                        name="Motivo"
                        {...selectProps(KEYS.motivo)}
                        onChange={e=>{selectProps(KEYS.motivo).onChange(e);
                            e.target.value?.label === 'Otros'
                            ? setIsOtros(true)
                            : setIsOtros(false);}}
                    />       
                    {isOtros && (
                        <InputTextArea
                            label="Detalle del motivo"
                            {...(isOtros ? commonProps(KEYS.motivoDetalle) : {})}
                        />
                    )}         
                </div>
            </div>
            <div className="modal-footer justify-content-end">
                <button
                    className="btn btn-primary generic-button-ficha mr-2"
                    disabled={isSending}
                    onClick={handleAction}>
                    No Aprobar {isSending && (<FontAwesomeIcon icon='spinner' transform="left-9" className="spinner ml-3" />)}
                </button>
                <button
                    className="btn btn-primary generic-button-ficha"
                    disabled={isSending}
                    onClick={() => { toggleModal() }}>
                    Cancelar
                </button>
            </div>
        </GenericModal>
    )
}

export default RechazarSolicitudBeneficio